import React, { Component } from 'react';
import Constants from '../../Config/Config';

class Frame extends Component {
	render() {
		const {selectedFrame, frameTotal} = this.props;
    return (
      <tr> 
  			<th>Style</th> 
  			<td>{selectedFrame.get('name')}</td> 
  			<td>{Constants.Currency + frameTotal}</td> 
      </tr>
    );
	}
}

export default Frame;